export const Get_DELIVERYEFFICIENCY_DATA= "Get_DELIVERYEFFICIENCY_DATA";
export const Get_DELIVERYEFFICIENCY_REPORT= "Get_DELIVERYEFFICIENCY_REPORT";
export const API_CALL_STATUS = "API_CALL_STATUS"